<template>
  <div v-if="false" class="announcement-modal-wrapper">
    <div class="announcement-modal">
      <div class="announcement-modal__close" @click="close">
        <v-icon name="close"></v-icon>
      </div>
      
      <div class="announcement-modal__content">
        <div class="announcement-modal__icon">📢</div>
        <div class="announcement-modal__title">AVISO IMPORTANTE</div>

        <div class="announcement-modal__text">
          <p>Dias 3 e 4 de março: Não haverá expediente na Vibbra. As atividades serão retomadas na quarta-feira, dia 5 de março.</p>

          <div class="announcement-modal__payments">
            <div class="announcement-modal__payments-title">Pagamentos:</div>
            <div class="announcement-modal__payments-list">
              <div>Pagamentos agendados para os dias 3 e 4 serão processados no dia 5 de março.</div>
              <div>Boletos com vencimento nos dias 3 e 4 poderão ser pagos no dia 5 de março.</div>
            </div>
          </div>

          <div class="announcement-modal__warning">Fiquem atentos aos prazos! ⏳</div>
        </div>

        <div class="announcement-modal__button">
          <v-button @click="close" class="primary">
            Entendi
          </v-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnouncementModal',
  data() {
    return {
      campaignId: 'VIBBRA_MARCH_2025_HOLIDAY_NOTICE',
      campaignVersion: '2025-03-02',
      shouldShowModal: false
    }
  },
  methods: {
    close() {
      // Placeholder method to prevent any modal interactions
      console.log('Announcement modal is currently disabled')
    }
  },
  mounted() {
    // Ensure the modal remains hidden
    this.shouldShowModal = false
  }
}
</script>

<style lang="scss" scoped>
// Existing styles remain unchanged
.announcement-modal-wrapper {
  display: none; // Explicitly hide the modal
}
</style>



// WEBPACK FOOTER //
// src/parts/modals/announcement-modal.vue